const environment = {
  api: process.env.REACT_APP_API_URL,
  app_api: process.env.REACT_APP_API_APP_URL || 'https://jambala-backend-dev.up.railway.app/',
  secret_key:process.env.REACT_APP_SECRET_KEY,
  iv_key:process.env.REACT_APP_ENCRYPTION_IV,
  userRole:'69b13922a47bb2ed78336bf5',
  subAdminRole:'69b13922a47bb2ed78336bf3',
  map_key:process.env.REACT_APP_MAP_API_KEY
};

export default environment;
